import { render, staticRenderFns } from "./TextImgComponent.vue?vue&type=template&id=e3da5c42&"
import script from "./TextImgComponent.vue?vue&type=script&lang=js&"
export * from "./TextImgComponent.vue?vue&type=script&lang=js&"
import style0 from "./TextImgComponent.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports